import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { useAuth } from './authContext'
import { keycloak, LOGIN_OPTIONS } from './keycloak'

/**
 * Route-level guard: redirects to Keycloak's hosted login when the user is
 * unauthenticated. Renders nothing while initializing or while the redirect is
 * in flight. Wrap protected route elements with this.
 *
 * Unlike the plain login button, this returns the user to the page they were
 * trying to reach (redirectUri = current URL) instead of home, while keeping the
 * required scopes from LOGIN_OPTIONS.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { initialized, authenticated } = useAuth()

  useEffect(() => {
    if (initialized && !authenticated) {
      keycloak.login({ ...LOGIN_OPTIONS, redirectUri: window.location.href })
    }
  }, [initialized, authenticated])

  if (!initialized || !authenticated) return null
  return <>{children}</>
}
